export default "__VITE_ASSET__CxWywzLV__"